// import { number, object, string, array } from 'yup';
import { IOptions } from '../util/interfaces';
import { InputType } from './FilterForm';

// export const standardSchema = object({
//     queryBuilder: array().of(object({
//         fieldName: string().required('Field name is required'),
//         operator: string().required('Operator is required'),
//         value: string().required('Value is required'),
//     })).nullable().required(),
//     hospitalId: array().of(string().required()).required(),
//     departmentId: array().of(string().required()).required(),
//     orderBy: string().required(),
// });

export interface IQueryBuilderSelects {
    name: 'fieldName' | 'operator';
    data: IOptions[];
}

export const operators: IQueryBuilderSelects = {
    name: 'operator',
    data: [
        { label: 'Starts With', value: 'startsWith' },
        { label: 'Contains Any Terms', value: 'containsAnyTerm' },
        { label: 'Contains All Terms', value: 'containsAllTerms' },
        { label: 'Contains All Terms In Order', value: 'containsAllTermsInOrder' },
        { label: 'Equals', value: 'equals' },
        { label: 'Not Equals', value: 'notEquals' },
        { label: 'Does Not Contain', value: 'doesNotContain' },
        { label: 'Greater Than', value: 'greaterThan' },
        { label: 'Less Than', value: 'lessThan' },
        { label: 'Greater Than or Equal', value: 'greaterThanEqual' },
        { label: 'Less Than or Equal', value: 'lessThanEqual' },
        { label: 'In Array', value: 'in' },
        { label: 'Not In Array', value: 'notIn' },
        { label: 'Is Empty', value: 'isEmpty' },
        { label: 'Is Not Empty', value: 'isNotEmpty' },
        { label: 'Is Null', value: 'isNull' },
        { label: 'Is Not Null', value: 'isNotNull' },
    ]
};

export const mockHospitalsInput: InputType<{ hospitalId: string[]; }> = {
    label: 'Hospital', type: 'checkbox', placeholder: 'Hospital', name: 'hospitalId', id: 'hospitalId', options: [
        { value: '100', label: 'Yale-New Haven Hospital - Lawrence Memorial Hospital' },
        { value: '101', label: 'AdventHealth - Hinsdale' },
        { value: '102', label: 'Group 3' },
    ]
};

export const mockDepartmentsInput: InputType<{ departmentId: string[]; }> = {
    label: 'Department', type: 'checkbox', placeholder: 'Department', name: 'departmentId', id: 'departmentId', options: [
        { value: '2975', label: 'Catheterization Lab' },
        { value: '4014', label: 'AdventHealth - Hinsdale - Cath-EP' },
        { value: '3772', label: 'Mt Sinai West - Interventional Radiology' },
    ]
};
